// Data display: indicators shown next to extracted fields. Saved per organisation.
import Toggle from '../Toggle'
import { Panel } from './SettingsPrimitives'

const TOGGLES = [
  { key: 'showConfidenceScore', spot: 'confidence', label: 'Confidence score', description: 'Percentage next to each value' },
  { key: 'showAiBadge', spot: 'ai', label: 'AI label', description: 'Badge on fields filled in by AI' },
  { key: 'showColorCoding', spot: 'colour', label: 'Colour coding', description: 'Highlights fields by confidence' },
]

export default function DisplaySection({ prefs, setPref, setAll, disabled, bindSpot }) {
  const allOn = TOGGLES.every(t => prefs[t.key])

  return (
    <Panel
      title="Field indicators"
      description="Applies to everyone in your organisation."
      actions={(
        <button
          type="button"
          onClick={() => setAll(!allOn)}
          disabled={disabled}
          className="text-[13px] font-medium text-navy-600 hover:underline disabled:opacity-50 disabled:no-underline dark:text-navy-300"
        >
          {allOn ? 'Turn all off' : 'Turn all on'}
        </button>
      )}
    >
      <div className="-my-1 divide-y divide-gray-100 dark:divide-gray-800">
        {TOGGLES.map(({ key, spot, label, description }) => {
          const flip = () => { if (!disabled) setPref(key, !prefs[key]) }
          return (
            // Whole row toggles; the switch stops propagation so it doesn't flip twice.
            <div
              key={key}
              {...bindSpot(spot)}
              onClick={flip}
              className={`flex items-center gap-4 py-3.5 ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
            >
              <div className="min-w-0 flex-1">
                <p className="text-[13.5px] font-medium text-gray-900 dark:text-gray-100">{label}</p>
                <p className="text-[13px] text-gray-500 dark:text-gray-400">{description}</p>
              </div>
              <Toggle
                checked={prefs[key]}
                onChange={e => { e.stopPropagation(); flip() }}
                disabled={disabled}
                title={label}
              />
            </div>
          )
        })}
      </div>
    </Panel>
  )
}
